exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._21eZngTL8w_lPF5MRiaQ_8{color:var(--neutralPrimary)}._2vVa6j49qnHEumA-Y638S{-webkit-box-flex:1;-ms-flex:1 1 auto;flex:1 1 auto;-ms-flex-item-align:center;align-self:center}html[dir=ltr] ._2vVa6j49qnHEumA-Y638S{padding-right:16px}html[dir=rtl] ._2vVa6j49qnHEumA-Y638S{padding-left:16px}@media (min-width:1260px){.FSplUwmhOE18ds3PjbwcF{position:fixed;top:8px}html[dir=ltr] .FSplUwmhOE18ds3PjbwcF{left:50%;-webkit-transform:translateX(-50%);transform:translateX(-50%)}html[dir=rtl] .FSplUwmhOE18ds3PjbwcF{right:50%;-webkit-transform:translateX(50%);transform:translateX(50%)}}", ""]);

// exports
exports.locals = {
	"customFlexPane": "_21eZngTL8w_lPF5MRiaQ_8",
	"searchContainer": "_2vVa6j49qnHEumA-Y638S",
	"searchContainerCentered": "FSplUwmhOE18ds3PjbwcF"
};